import { Injectable } from "@angular/core";
import { UTCDate } from "@ankaadia/ankaadia-shared";
import { reportProgress } from "@ankaadia/ankaadia-shared-frontend";
import {
    BillingTableType,
    ExcelAddInDto,
    GetAvailableOrganizationsGQL,
    GetBillingDataGQL,
    GetBillingDataSubscription,
    OrganizationListDto,
} from "@ankaadia/graphql";
import type { FetchResult } from "@apollo/client/core";
import { Observable, map } from "rxjs";

@Injectable({ providedIn: "root" })
export class BillingDataService {
  constructor(
    private readonly getAvailableOrganizationsQuery: GetAvailableOrganizationsGQL,
    private readonly getBillingDataQuery: GetBillingDataGQL
  ) {}

  getOrganizationData(): Observable<OrganizationListDto> {
    return this.getAvailableOrganizationsQuery.subscribe().pipe(
      map((result) => result.data.getAvailableOrganizations),
      reportProgress("getAvailableOrganizations", "1", false, { silent: true })
    );
  }

  getBillingData(
    language: string,
    fromDate: UTCDate,
    toDate: UTCDate,
    tables: BillingTableType[],
    allOrganizations: boolean,
    organizationId: string,
    includeVirtualBookings: boolean
  ): Observable<ExcelAddInDto> {
    return this.getBillingDataQuery
      .subscribe({
        input: {
          language: language,
          fromDate: fromDate,
          toDate: toDate,
          allOrganizations: allOrganizations,
          organizationId: organizationId,
          includeVirtualBookings: includeVirtualBookings,
          tables: tables,
        },
      })
      .pipe(
        map((result: FetchResult<GetBillingDataSubscription>) => result.data.getBillingData),
        reportProgress("getBillingData", "1", false, { silent: true })
      );
  }
}
